export const UPDATE_OWNER = 'UPDATE_OWNER';
export const UPDATE_CAPITAL = 'UPDATE_CAPITAL';
export const UPDATE_TOPICS = 'UPDATE_TOPICS';
export const UPDATE_LOADED = 'UPDATE_LOADED';
export const UPDATE_LOADING_ERROR = 'UPDATE_LOADING_ERROR';


// WEBPACK FOOTER //
// ./src/store/mutation-types.js